// The host key identifies this device's host across sessions: "HOST-" plus 20 characters,
// issued by the server when a session is created (or on request) and kept in local storage.
// It is sent as X-Host-Key on every request (see api/client.js) and can be exported to another
// device by typing it into the code box or opening a link that carries it.

const STORAGE_KEY = "hostKey";

export const HOST_KEY_PREFIX = "HOST-";
export const HOST_KEY_LENGTH = HOST_KEY_PREFIX.length + 20;

const PATTERN = /^HOST-[A-Z0-9]{20}$/;

/** True while the value being typed or pasted is a host key rather than a session code. */
export const looksLikeHostKey = (value) => (value || "").trim().toUpperCase().startsWith(HOST_KEY_PREFIX);

/** The key in canonical form, or null when the value is not a well-formed key. */
export const normalizeHostKey = (value) => {
  const normalized = (value || "").trim().toUpperCase();
  return PATTERN.test(normalized) ? normalized : null;
};

export const getHostKey = () => {
  try {
    return normalizeHostKey(localStorage.getItem(STORAGE_KEY));
  } catch {
    return null;
  }
};

export const setHostKey = (key) => {
  const normalized = normalizeHostKey(key);
  if (!normalized) return null;
  try {
    localStorage.setItem(STORAGE_KEY, normalized);
  } catch {
    // storage unavailable (private mode): the key lives for this page only
  }
  return normalized;
};

export const clearHostKey = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // nothing to clear
  }
};

/** A link that puts the key on another device; with a session code it also joins that session as host. */
export const hostKeyLink = (key, sessionCode) =>
  `${window.location.origin}/${sessionCode || ""}?key=${encodeURIComponent(key)}`;
